export const codeList = {
  CODE: 'code',
  NAME: 'name',
  NAME_LANGUAGE_ID: 'name_language_id',
  WORD_NAME: 'word_name',
  WORD_LANGUAGE_ID: 'word_language_id',
  CODING: 'coding',
  CODING__EXCLUDE: 'coding__exclude',
  OFFSET: 'offset',
  LIMIT: 'limit',
  LANGUAGE_ID: 'language_id',
  CODE__EXACT: 'code__exact',
  CODING_GROUP__EXACT: 'coding_group',
};
